var exports = {
  "kL": "x43aef4ae--b6cede--container",
  "Lp": "x43aef4ae--b6cede--image-wrapper-inner",
  "Qs": "x43aef4ae--b6cede--content",
  "DD": "x43aef4ae--b6cede--title",
  "kZ": "x43aef4ae--b6cede--image-wrapper",
  "Jq": "x43aef4ae--b6cede--promo-label-wrapper",
  "rP": "x43aef4ae--b6cede--transports-wrapper",
  "G6": "x43aef4ae--b6cede--rooms-info-wrapper",
};

module.exports = exports;
